import React from 'react';
import { twMerge } from 'tailwind-merge';

const App = ({
  children,
  customClass,
  customContainerClass,
}: {
  children: React.ReactNode;
  customClass?: string;
  customContainerClass?: string;
}) => (
  <div
    className={twMerge('p-2 md:p-3 pb-0', customContainerClass)}
    style={{ zIndex: 200 }}
  >
    <div
      className={twMerge(
        'w-full rounded-lg border-gray-200 border bg-white px-4 py-2 pb-6',
        customClass,
      )}
    >
      {children}
    </div>
  </div>
);

export default App;
